var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-editor-base", {
    attrs: { label: _vm.label },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var inputId = ref.inputId
          return [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.model,
                    expression: "model"
                  }
                ],
                staticClass: "form-control",
                attrs: { id: inputId },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.model = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _vm.placeholder
                  ? _c("option", [_vm._v(_vm._s(_vm.placeholder))])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.mappedOptions, function(option) {
                  return _c(
                    "option",
                    { key: option.value, domProps: { value: option.value } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.text) +
                          "\n            "
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }